const ADS_SCRIPT_ID = 'google-ads-gtag';
const DEFAULT_GOOGLE_ADS_ID = 'AW-980565318';

const getAdsId = () => (process.env.REACT_APP_GOOGLE_ADS_ID || DEFAULT_GOOGLE_ADS_ID).trim();
const getRegisterLabel = () => (process.env.REACT_APP_GOOGLE_ADS_REGISTER_LABEL || '').trim();

export const ensureGoogleAdsTag = () => {
  const adsId = getAdsId();
  if (!adsId || typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(adsId)}`;
  const hasScriptAlready = Boolean(
    document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${encodeURIComponent(adsId)}"]`)
  );

  if (!document.getElementById(ADS_SCRIPT_ID) && !hasScriptAlready) {
    const script = document.createElement('script');
    script.id = ADS_SCRIPT_ID;
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', adsId);
  return true;
};

export const trackRegisterConversion = () => {
  const adsId = getAdsId();
  const label = getRegisterLabel();
  if (!adsId || !label || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return false;
  }

  window.gtag('event', 'conversion', {
    send_to: `${adsId}/${label}`,
  });
  return true;
};
